<template>
  <div class="tasks tasks-show"
       v-loading="loading">
    <Tem>
      <template slot="close">
        <el-button type="text"
                   @click="closeDialog()"
                   icon="el-icon-arrow-left"></el-button>
      </template>
      <template slot="header-btn">
        <el-button type="primary"
                   size="mini"
                   class="add-reading"
                   :disabled="savePermisson"
                   v-if="form.TaskType === 2"
                   @click="openAddReadingDialog()">{{$t('model.AddReading')}}</el-button>
      </template>
      <template slot="title">{{$t('model.Task')}}</template>
      <template slot="form">
        <el-form label-width="130px"
                 label-position="top"
                 size="mini">
          <el-form-item :label="$t('model.Name')"
                        key="name">
            <el-input v-model="form.Name"
                      size="mini"></el-input>
          </el-form-item>
          <el-form-item v-if="form.TaskType === 0"
                        :label="$t('model.Category')">
            <el-select v-model="form.WorkType"
                       clearable
                       size="mini">
              <el-option v-for=" i of taskWorkType"
                         :key="i.Value"
                         :label="$t('api.'+i.Key)"
                         :value="i.Value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('model.Status')">
            <el-select v-model="form.Status"
                       clearable
                       size="mini">
              <el-option v-for=" i of taskStatus"
                         :key="i.Value"
                         :label="$t('api.'+i.Key)"
                         :value="i.Value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.TaskType !== 2"
                        :label="$t('model.%Done')">
            <el-select v-model="form.CompletionRate"
                       size="mini"
                       filterable
                       allow-create
                       default-first-option
                       @blur.native.capture="setManualCompletionRate"
                       @change="changeRate"
                       :disabled="form.TaskType === 4">
              <el-option v-for="p of tasksProgressOptions"
                         :key="p.Key"
                         :label="p.Value"
                         :value="p.Key"></el-option>
            </el-select>
          </el-form-item>
          <template v-if="form.TaskType === 1">
            <el-form-item :label="$t('model.Product')">
              <span style="color:#4193f6;display:block;line-height:1em">
                {{form.TaskProduct.SKU}}
              </span>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item :label="$t('model.NetArea')"
                              v-if="form.TaskProduct.AssignType === 1">
                  <el-tag size="medium">
                    {{form.Product.transformNetArea}}
                  </el-tag>
                  {{form.Product.Unit}}
                </el-form-item>
              </el-col>
              <el-col :span="form.TaskSubtype===1?24:12">
                <el-form-item :label="$t('model.TaskTotalQty')"
                              prop="taskTotalQty"
                              :class="form.TaskSubtype===1?'is-required':''"
                              :style="form.TaskSubtype===1?'margin-bottom: 5px;':''"
                              key="2"
                              :rules="rules.taskTotalQty">
                  <el-input v-if="form.TaskSubtype===1"
                            size="mini"
                            style="width:95%"
                            v-model="form.Product.transformTotal"
                            min="0"
                            :placeholder="$t('model.TaskTotalQty')"
                            @input="taskTotalOnInput">
                    <template slot="append">
                      <span>
                        {{$t('model.RetainageQty')}}: {{nonM2Product.RetainageQty}} {{$config.getNonM2ProductUnit(nonM2Product.Unit)}}
                      </span>
                      <span style="margin-left:8px">
                        {{$t('model.JobsiteTotalQty')}}: {{nonM2Product.Quantity}} {{$config.getNonM2ProductUnit(nonM2Product.Unit)}}
                      </span>
                    </template>
                  </el-input>
                  <el-tag v-else
                          size="medium">
                    {{form.Product.transformTotal}}
                  </el-tag>
                  <span v-if="form.TaskSubtype!==1"> {{form.Product.Unit}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('model.QtyInstalled')">
                  <el-tag size="medium">
                    {{normalProductInstallQty}}
                  </el-tag>
                  {{form.Product.Unit}}
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <template v-if="form.TaskType === 2">
            <el-form-item :label="$t('taskDialog.MaxRh')">
              <el-slider show-input
                         :max="99"
                         :min="75"
                         v-model="form.MaxRh">
              </el-slider>
            </el-form-item>
            <el-form-item :label="$t('taskDialog.RHInConcrete') ">
              <el-tag size="medium">
                {{form.Reading.lastRel.ConcreteRH?form.Reading.lastRel.ConcreteRH:'-'}}%
              </el-tag>
            </el-form-item>
            <el-form-item :label="$t('taskDialog.HoleDepth')">
              <el-input v-model="form.DepthFromTopOfSlab"
                        size="mini"
                        :placeholder="$t('taskDialog.HoleDepth')"></el-input>
            </el-form-item>
            <el-form-item style="margin-top:5px">
              <el-row style="line-height: 24px;">
                <el-col :span="12">
                  <el-checkbox v-model="form.SleeveDropped"
                               @change="sleeveDroppedChange">Sleeved dropped</el-checkbox>
                </el-col>
                <el-col :span="12">
                  <span v-show="form.SleeveDropped">{{this.form.SleeveDroppedDate ? this.$config.formatDate(new Date(this.form.SleeveDroppedDate)) :''}}</span>
                </el-col>
              </el-row>
            </el-form-item>
            <template v-if="form.Reading.lastCal.PhTesting">
              <el-row>
                <el-col :span="12">
                  <el-form-item :label="$t('taskDialog.PHTesting')">
                    <el-tag size="medium">
                      {{form.Reading.lastCal.PhTesting}}
                    </el-tag>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('taskDialog.StartingWeight')">
                    <el-tag size="medium">
                      {{form.Reading.lastCal.StartingWeight}}
                    </el-tag>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('taskDialog.EndingWeight')">
                    <el-tag size="medium">
                      {{form.Reading.lastCal.EndingWeight}}
                    </el-tag>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('taskDialog.NetWeightGain')">
                    <el-tag size="medium">
                      {{(form.Reading.lastCal.EndingWeight - form.Reading.lastCal.StartingWeight).toFixed(1)}}
                    </el-tag>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="MVER">
                <el-tag size="medium">
                  {{form.Reading.lastCal.VaporEmission}}
                </el-tag>
              </el-form-item>
            </template>
          </template>
          <el-form-item :label="$t('model.TaskGroup')">
            <el-select v-model="form.TaskPhaseId"
                       clearable
                       size="mini">
              <el-option v-for="i of taskGroup"
                         :key="i.PhaseId"
                         :label="i.Name"
                         :value="i.PhaseId"></el-option>
            </el-select>
            <el-button circle
                       type="primary"
                       size="mini"
                       v-has="'Create Task Group'"
                       :title="$t('groupDialog.AddTaskGroup')"
                       style="position: absolute;top: -120%;right:0"
                       @click="openGroupDialog"><i class="el-icon-plus"></i></el-button>
          </el-form-item>
          <el-form-item :label="$t('model.StartDate')">
            <el-date-picker v-model="form.StartDate"
                            size="mini"
                            :placeholder="$t('model.Select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('model.DueDate')">
            <el-date-picker v-model="form.EndDate"
                            size="mini"
                            :placeholder="$t('model.Select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('taskDialog.completed')"
                        key="completionDate">
            <el-date-picker v-model="form.CompletionDate"
                            size="mini"
                            :placeholder="$t('model.Select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('model.Assignee')"
                        key="assignee">
            <el-select @change="changeAssign"
                       :disabled='userInfo.RoleType === 4'
                       clearable
                       v-model="assign"
                       size="mini"
                       :placeholder="$t('model.SelectAssignee')">
              <el-option v-for="item in projectUser"
                         :key="item.UserId"
                         :label="item.FullName"
                         :value="item.UserId">
                <div class="user-logo">
                  <img :src="item.AvatarUrl"
                       alt="">
                </div>
                <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('model.Watching')"
                        key="watching">
            <el-select v-model="form.WatchingUserIds"
                       clearable
                       size="mini"
                       multiple
                       :placeholder="$t('model.SelectWatching')">
              <el-option v-for="item in projectUser"
                         :key="item.UserId"
                         :label="item.FullName"
                         :value="item.UserId">
                <div class="user-logo">
                  <img :src="item.AvatarUrl"
                       alt="">
                </div>
                <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('model.Location')">
            <div v-if='form.PlanType === 0 && form.PlanId !== null'>
              <el-tag v-for="i of this.shapeList"
                      style="margin-right:5px"
                      :key="(i.ShapeName,i.RoomShapeId)">{{i.ShapeName}}</el-tag>
            </div>
            <el-input v-else
                      v-model="locationText"
                      size="mini"
                      :placeholder="$t('taskDialog.Location')"></el-input>
          </el-form-item>
          <template v-if="form.TaskType === 4">
            <el-divider></el-divider>
            <div v-for="i in children"
                 :key="i.type">
              <el-form-item :label="i.Name +' '+ i.rate +'%'"
                            class="tem">
                <InputRadioSelectPopover v-model="i.rate"
                                         :disabled="savePermisson"
                                         :btnStyle="0"
                                         @change="changeChildGroup(i.list,i.rate)">
                </InputRadioSelectPopover>
                <el-table size="mini"
                          class="product-table"
                          :data="i.list"
                          :show-header="false">
                  <el-table-column>
                    <template slot-scope="scope">
                      <ProductInfo v-model="scope.row.CompletionRate"
                                   :product="scope.row.ProductInfo"
                                   :disableInputRadioSelect="savePermisson"
                                   @changeCompletionRate="changeChild(scope.row.TaskId, scope.row.CompletionRate)"></ProductInfo>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </div>
          </template>
          <template v-if="form.TaskType === 2">
            <div class="reading-box"
                 v-if="form.Reading.show.length>0">
              <el-divider></el-divider>
              <el-table size="mini"
                        class="reading-table"
                        :data="form.Reading.show"
                        @row-click="openReadingList()"
                        :show-header="false">
                <el-table-column>
                  <template slot-scope="scope">
                    <div v-if="scope.row.type === 'rel'">
                      <span class="time">{{scope.row.CreatedOn.substring(0, 10)}}</span>
                      <div v-if="scope.row.PhTesting">
                        <span class="text">{{$t('taskDialog.PHTesting')}}: {{scope.row.PhTesting}}</span>
                      </div>
                      <div>
                        {{$t('taskDialog.ConCrete')}}:
                        <span class="text"
                              v-if="scope.row.ConcreteTemperature">{{$config.getFormatTemperature(scope.row.ConcreteTemperature,temperatureUnit)}}, </span>
                        <span class="text">{{scope.row.ConcreteRH?scope.row.ConcreteRH:'0.0'}}%</span>
                      </div>
                      <div v-if="scope.row.AmibientRh || scope.row.AmbientTemperature">
                        {{$t('taskDialog.Ambient')}}:
                        <span class="text"
                              v-if="scope.row.AmbientTemperature">{{$config.getFormatTemperature(scope.row.AmbientTemperature,temperatureUnit)}},</span>
                        <span class="text"
                              v-if="scope.row.AmibientRh"> {{scope.row.AmibientRh}}%</span>
                      </div>
                      <span class="text"
                            v-if="scope.row.ConcreteSurfaceTemperature">{{$t('taskDialog.SurfaceTemp')}}: {{$config.getFormatTemperature(scope.row.ConcreteSurfaceTemperature,temperatureUnit)}}</span>
                    </div>
                    <div v-if="scope.row.type === 'cal'">
                      <div>
                        <span class="time">{{scope.row.StartTime}} - {{scope.row.EndTime}}</span>
                      </div>
                      <div>
                        <span class="text">{{$t('taskDialog.PHTesting')}}: {{scope.row.PhTesting}}</span>
                      </div>
                      <div>
                        <span class="text">{{$t('taskDialog.StartingWeight')}}: {{scope.row.StartingWeight}}g</span>
                      </div>
                      <div>
                        <span class="text">{{$t('taskDialog.EndingWeight')}}: {{scope.row.EndingWeight}}g </span>
                      </div>
                      <div>
                        <span class="text">
                          MVER:{{scope.row.VaporEmission}}
                        </span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-button size="mini"
                         style="width:100%;margin-top:10px"
                         @click="openReadingList()"
                         v-if="form.Reading.list.length>1">{{$t('taskDialog.MoreReading')}}</el-button>
            </div>
          </template>
          <el-divider></el-divider>
          <el-table :data="form.TaskPhotos"
                    class="img-table"
                    :show-header="false">
            <el-table-column width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.Type === 'TaskVideo'"
                     class="videoPlayContent"
                     @click="openBig(scope.row.url, true)">
                  <div class="videoPlayDiv"><span class="videoPlay"></span></div>
                  <img style="width:100%;"
                       :src="scope.row.videoThumbUrl" />
                </div>
                <img v-else
                     :src="scope.row.url"
                     @click="openBig(scope.row.url)"
                     alt="">
              </template>
            </el-table-column>
            <el-table-column @click="openBig">
              <template slot-scope="scope">
                <span :title="scope.row.Name"
                      @click="openBig(scope.row.url,scope.row.Type === 'TaskVideo')"
                      style="cursor: pointer;white-space: nowrap;">
                  {{scope.row.Name}}
                </span>
              </template>
            </el-table-column>
            <el-table-column width="50"
                             style="text-align：left">
              <template slot-scope="scope">
                <el-button size="mini"
                           circle
                           :disabled="savePermisson"
                           @click="deleteTaskPhoto(scope.row)"
                           type="danger">
                  <i class="el-icon-delete"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary"
                     size="mini"
                     style="width:100%"
                     :disabled="savePermisson"
                     @click="openUpload(true)">{{$t('taskDialog.AddPhoto')}} / {{$t('taskDialog.Video')}}</el-button>
          <el-divider></el-divider>
          <el-table :data="form.TaskFiles"
                    class="file-table"
                    :show-header="false">
            <el-table-column width="60">
              <template slot-scope="scope">
                <div class="file-img-div">
                  <i @click="downloadFile(scope.row.DocFileId, scope.row.Name)">
                    <img :src="require('../../assets/image/file_type/' + $config.getIconForFileType(scope.row.Name))"
                         class="file-icon"
                         :style="scope.row.IsImage?'width:100%;':''" />
                  </i>
                </div>
              </template>
            </el-table-column>
            <el-table-column @click="downloadFile">
              <template slot-scope="scope">
                <span :title="scope.row.Name"
                      @click="downloadFile(scope.row.DocFileId, scope.row.Name)"
                      style="cursor: pointer;white-space: nowrap;">
                  {{scope.row.Name}}
                </span>
              </template>
            </el-table-column>
            <el-table-column width="50"
                             style="text-align：left">
              <template slot-scope="scope">
                <el-button size="mini"
                           circle
                           :disabled="savePermisson"
                           @click="deleteTaskFile(scope.row)"
                           type="danger">
                  <i class="el-icon-delete"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-dropdown @command="handleTaskFileCommand"
                       placement="top"
                       trigger="click"
                       style="width:100%;">
            <el-button type="primary"
                       size="mini"
                       :disabled="savePermisson"
                       style="width:100%">
              {{$t('taskDialog.AddFile')}}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="composeTaskFileCommand(1)">{{$t('taskDialog.FromLocalDisk')}}</el-dropdown-item>
              <el-dropdown-item :command="composeTaskFileCommand(2)">{{$t('taskDialog.FromProjectDocuments')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-divider></el-divider>
          <checklist :id="id"
                     :savePermisson="savePermisson"
                     @setrefreshflag="setrefreshflag"></checklist>
          <el-divider></el-divider>
          <el-form-item :label="$t('model.Description')"
                        style="margin-bottom:10px">
            <el-input type="textarea"
                      v-model="form.Description"
                      :autosize="{ minRows: 2, maxRows: 4}"
                      :placeholder="$t('model.DescribeTheTask')"></el-input>
          </el-form-item>
          <el-divider></el-divider>
          <el-button size="mini"
                     type="danger"
                     style="width:100%"
                     v-has="'Delete Task'"
                     @click="deleteTask()">{{$t('model.Delete')}}</el-button>
        </el-form>
      </template>
      <template slot="footer">
        <el-button size="mini"
                   type="primary"
                   :loading="btnLoading"
                   :disabled="savePermisson"
                   @click="save()">{{$t('model.Save')}}</el-button>
        <el-button size="mini"
                   type="primary"
                   :disabled="savePermisson"
                   v-if="form.TaskType !== 2"
                   @click="markAsDone()">{{$t('model.MarkAsDone')}}</el-button>
      </template>
    </Tem>
    <Group-Dialog :showDialog="groupDialog.showDialog"
                  :jobsiteId="form.JobsiteId"
                  @closeDialog="closeGroupDialog"></Group-Dialog>
    <Uploading :showDialog="uploadDialog.showDialog"
               @closeDialog="closeUpload"
               :taskId="uploadDialog.taskId"
               :onlyPhotoVideo="uploadDialog.onlyPhotoVideo"></Uploading>
    <photoDialog :showDialog="photoDialog.showDialog"
                 @closeDialog="closeBig()"
                 :url="photoDialog.url"
                 :isVideo="photoDialog.isVideo"></photoDialog>
    <AddReading-Dialog :showDialog="addReadingDialog.showDialog"
                       :taskId="addReadingDialog.taskId"
                       :maxRh="addReadingDialog.maxRh"
                       @closeDialog="closeAddReadingDialog"></AddReading-Dialog>
    <div class="Reading-List">
      <Reading-List :showDialog="readingList.showDialog"
                    @closeDialog="closeReadingList"
                    :savePermisson="savePermisson"
                    :list="readingList.list"></Reading-List>
    </div>
    <selectProjectFileDialog :showDialog="selectProjectFileDialog.showDialog"
                             @closeDialog="closeProjectFileDialog"
                             :taskId="selectProjectFileDialog.taskId"
                             :taskFileIds="selectProjectFileDialog.taskFileIds">
    </selectProjectFileDialog>
  </div>
</template>

<script>
import {
  getTaskById, getTaskReadingCal, getTaskReadingRel, deleteTask, addTask,
  deleteTaskPhoto, changeChild, deleteFile, getFileList, getTaskPhoto, getProductById
} from '@/api/config'
import GroupDialog from '@components/group/groupDialog'
import Uploading from '@components/uploading/uploading'
import photoDialog from '@components/photo/photoDialog.vue'
import AddReadingDialog from '@components/task/addReadingDialog'
import ReadingList from '@components/task/readingList'
import selectProjectFileDialog from '@components/project/selectProjectFileDialog.vue'
import checklist from '@components/task/checklist.vue'
import { mapState } from 'vuex'
import Tem from './layout/taskTemplate'
import InputRadioSelectPopover from '@components/common/InputRadioSelectPopover'
import ProductInfo from '@components/common/ProductInfo'
import axios from 'axios'
import _ from 'lodash'
export default {
  data () {
    const checkTaskTotalQty = (rule, value, callback) => {
      if (value !== this.form.Product.transformTotal) {
        value = this.form.Product.transformTotal
      }
      if (!value || parseFloat(value) <= 0) {
        return callback(new Error(this.$t('productDialog.QuantityMustGreaterThan0')))
      }
      if (parseFloat(value) > this.nonM2Product.RetainageQty) {
        return callback(new Error(this.$t('model.TaskTotalQtyCannotGreaterThanJobsiteRetaingeQty')))
      } else {
        callback()
      }
    }
    return {
      closeNeedRefresh: false,
      btnLoading: false,
      children: [],
      assign: '',
      loading: false,
      groupDialog: {
        showDialog: false
      },
      uploadDialog: {
        showDialog: false,
        taskId: null,
        onlyPhotoVideo: false
      },
      photoDialog: {
        showDialog: false,
        url: '',
        isVideo: false
      },
      addReadingDialog: {
        showDialog: false,
        taskId: null,
        maxRh: 0
      },
      readingList: {
        showDialog: false,
        list: []
      },
      selectProjectFileDialog: {
        showDialog: false,
        taskId: null,
        taskFileIds: []
      },
      cover: -1,
      form: {},
      groupRate: 0,
      condition: {
        JobsiteId: null,
        TaskId: null,
        PageIndex: 1,
        PageSize: 1000,
        OrderBy: 'LastUpdatedOn desc'
      },
      shapeList: [],
      locationText: '',
      savePermisson: false,
      nonM2Product: {
        SKU: null,
        Quantity: 0,
        Unit: null,
        RetainageQty: 0
      },
      rules:
      {
        taskTotalQty: [{
          validator: checkTaskTotalQty, trigger: 'blur'
        }]
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'mockUserInfo', 'jobsiteID', 'taskStatus', 'taskType', 'taskWorkType', 'temperatureUnit', 'taskGroup', 'projectUser']),
    id () {
      return this.$route.params.id
    },
    tasksProgressOptions () {
      return this.$store.state.diag.data.tasksProgressOptions
    },
    normalProductInstallQty () {
      let totalQty = this.form.Product.NetArea ? this.form.Product.transformNetArea : this.form.Product.transformTotal
      if (totalQty.replace) {
        totalQty = parseFloat(totalQty.replace(/,/g, ''))
      }
      let transformInstallQty = this.$config.numberFormat(this.$config.getFormatNumber(totalQty * parseFloat(this.form.CompletionRate) / 100, 2))
      if (this.form.Product.Unit === 'EA') {
        transformInstallQty = Math.ceil(transformInstallQty)
      }
      return transformInstallQty
    },
    productList () {
      return this.$store.state.diag.data.productList
    }
  },
  created () {
  },
  mounted () {
    this.getTaskById()
  },
  watch: {
    id (to, from) {
      this.readList = []
      this.assign = ''
      this.readingList.showDialog = false
      this.children = []
      this.locationText = ''
      if (to) {
        this.getTaskById()
      }
    },
    productList (to, from) {
      this.setChildrenProductInfo(to)
    }
  },
  methods: {
    setManualCompletionRate (e) {
      let value = e.target.value
      if (value) {
        this.changeRate(value)
      }
    },
    sleeveDroppedChange () {
      if (this.form.SleeveDropped) {
        this.form.SleeveDroppedDate = this.$config.UTCTime(new Date())
      } else {
        this.form.SleeveDroppedDate = null
      }
    },
    setrefreshflag () {
      this.$store.commit('diag/setRefreshTaskList', true)
    },
    taskTotalOnInput (value) {
      value = value.replace(/[^0-9.]/g, '')
      value = value.indexOf('.') > -1 ? value.slice(0, value.indexOf('.') + 3) : value
      this.form.Product.transformTotal = value || 0.00
      this.$forceUpdate()
    },
    getTaskPhoto () {
      this.condition.JobsiteId = this.jobsiteID
      this.condition.TaskId = this.id
      getTaskPhoto(this.condition).then(res => {
        res.Data.forEach(ele => {
          ele.LastUpdatedOn = this.$config.LocalTime(new Date(ele.LastUpdatedOn))
          ele.checked = false
          ele.url = this.$config.baseURL + '/api/Attachments/' + ele.DocFileId
          ele.videoThumbUrl = ele.url
          if (ele.Type === 'TaskVideo') {
            ele.videoThumbUrl += '?getVideoThumbImg=true'
          }
        })
        this.form.TaskPhotos = res.Data
      })
    },
    changeAssign () {
      this.form.AssignedUserIds = []
      if (this.assign.length < 1) {
        this.form.AssignedUserIds = []
      } else {
        this.form.AssignedUserIds.push(this.assign)
      }
    },
    async closeReadingList (needRefresh) {
      if (needRefresh === true) {
        this.form.Reading = await this.getReading(this.id)
        this.$store.commit('diag/setRefreshTaskList', true)
      }
      this.readingList.showDialog = false
    },
    openReadingList () {
      this.readingList.list = this.form.Reading.list
      this.readingList.showDialog = true
    },
    async closeAddReadingDialog (needRefresh) {
      if (needRefresh === true) {
        this.form.Reading = await this.getReading(this.id)
        this.$store.commit('diag/setRefreshTaskList', true)
      }
      this.addReadingDialog.showDialog = false
      this.addReadingDialog.maxRh = 0
    },
    openAddReadingDialog () {
      this.addReadingDialog.showDialog = true
      this.addReadingDialog.taskId = this.id
      this.addReadingDialog.maxRh = this.form.MaxRh
    },
    deleteTaskPhoto (item) {
      this.$confirm(this.$t('model.AreYouSureYouWantToDeleteThisPhoto'), this.$t('model.TIPS'), {
        confirmButtonText: this.$t('model.Yes'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        cancelButtonText: this.$t('model.No'),
        type: 'warning'
      }).then(() => {
        let params = []
        params.push(item.DocFileId)
        deleteTaskPhoto(params).then(res => {
          this.getTaskPhoto()
          this.$store.commit('diag/setRefreshTaskList', true)
        })
      }).catch(() => {
      })
    },
    openBig (url, isVideo) {
      this.photoDialog.showDialog = true
      this.photoDialog.url = url
      this.photoDialog.isVideo = isVideo
    },
    closeBig () {
      this.photoDialog.showDialog = false
      this.photoDialog.url = ''
      this.photoDialog.isVideo = false
    },
    closeUpload (needRefresh) {
      this.uploadDialog.showDialog = false
      if (this.uploadDialog.onlyPhotoVideo) {
        this.getTaskPhoto()
      } else {
        this.getTaskFiles()
      }
      if (needRefresh === true) {
        this.$store.commit('diag/setRefreshTaskList', true)
      }
    },
    openUpload (onlyPhotoVideo) {
      this.uploadDialog.taskId = this.id
      this.uploadDialog.showDialog = true
      this.uploadDialog.onlyPhotoVideo = onlyPhotoVideo
    },
    closeGroupDialog (id) {
      if (id) {
        this.$store.dispatch('getTaskGroup').then(() => {
          this.$nextTick(() => {
            this.form.TaskPhaseId = id
          })
        })
      }
      this.groupDialog.showDialog = false
    },
    openGroupDialog () {
      this.groupDialog.showDialog = true
    },
    closeDialog (needRefresh) {
      let routername = 'taskList'
      if (this.$route.name === 'modelTask2') {
        routername = 'taskList2'
      }
      this.$router.push({
        name: routername
      })
      if (needRefresh === true) {
        this.$store.commit('diag/setRefreshTaskList', true)
      }
    },
    async getReading (id) {
      let condition = {
        TaskId: id,
        PageIndex: 1,
        PageSize: 100,
        OrderBy: 'LastUpdatedOn desc'
      }
      let reading = {
        lastCal: {},
        lastRel: {},
        list: [],
        show: []
      }
      await getTaskReadingCal(condition).then(res => {
        if (res.Data.length > 0) {
          reading.lastCal = res.Data[0]
          reading.lastCal.PhTesting = this.$config.getFormatNumber(reading.lastCal.PhTesting)
          reading.lastCal.EndingWeight = this.$config.getFormatNumber(reading.lastCal.EndingWeight)
          reading.lastCal.StartingWeight = this.$config.getFormatNumber(reading.lastCal.StartingWeight)
          reading.lastCal.VaporEmission = this.$config.getFormatNumber(reading.lastCal.VaporEmission)
          res.Data.forEach(ele => {
            for (let i in ele) {
              if (ele[i]) {
                if (typeof (ele[i]) === 'number' && i !== 'CreatorId') {
                  ele[i] = this.$config.getFormatNumber(ele[i])
                }
                if (i === 'EndTime' || i === 'StartTime') {
                  ele[i] = this.$config.LocalTime(ele[i])
                }
              }
            }
            ele.type = 'cal'
            reading.list.push(ele)
          })
        }
      })
      await getTaskReadingRel(condition).then(res => {
        if (res.Data.length > 0) {
          reading.lastRel = res.Data[0]
          reading.lastRel.ConcreteRH = this.$config.getFormatNumber(reading.lastRel.ConcreteRH)
        }
        res.Data.forEach(ele => {
          for (let i in ele) {
            if (ele[i]) {
              if (typeof (ele[i]) === 'number' && i !== 'CreatorId') {
                ele[i] = this.$config.getFormatNumber(ele[i])
              }
            }
          }
          ele.type = 'rel'
          reading.list.push(ele)
        })
      })
      if (reading.list.length > 0) {
        reading.list.forEach(i => {
          i.CreatedOnTag = this.$config.LocalTime(new Date(i.CreatedOn))
        })
        reading.list.sort(function (a, b) {
          return a.CreatedOn < b.CreatedOn ? 1 : -1
        })
        reading.show.push(reading.list[0])
        if (this.form.TaskId) {
          for (let i of reading.list) {
            if (i.type === 'rel') {
              let params = []
              if (i.ConcreteRH < this.form.MaxRh) {
                this.form.CompletionRate = 100
                this.form.Status = 'Completed'
                this.form.CompletionDate = this.$config.UTCTime(null, true)
                params.push(this.form)
                addTask(params).then(res => {
                  this.$store.dispatch('diag/getTasksList')
                })
                break
              } else {
                this.form.CompletionRate = 0
                this.form.CompletionDate = null
                params.push(this.form)
                addTask(params, true).then(res => {
                  this.$store.dispatch('diag/getTasksList')
                })
                break
              }
            }
          }
        }
      }
      return reading
    },
    async getTaskById () {
      this.loading = true
      let form
      await getTaskById(this.id).then(res => {
        form = res
      })
      if (this.userInfo.RoleType === 4) {
        if (form.AssignedUserIds.indexOf(this.userInfo.UserId) < 0) {
          this.savePermisson = true
        } else {
          this.savePermisson = false
        }
      }
      if (this.mockUserInfo && this.mockUserInfo.UserId) {
        this.savePermisson = true
      }
      if (this.taskGroup.length > 0) {
        let group = form.TaskPhaseId
        for (let item of this.taskGroup) {
          if (group === item.PhaseId) {
            form.TaskPhaseId = item.PhaseId
            break
          } else {
            form.TaskPhaseId = ''
          }
        }
      } else {
        form.TaskPhaseId = ''
      }
      let point = {
        x: form.LocationX,
        y: form.LocationY
      }
      this.$store.commit('diag/setSelectPoint', point)
      this.$store.commit('diag/setCenterPoint', point)
      this.$store.commit('diag/setTaskShape', form.TaskShapes)
      form.TaskPhotos.forEach(ele => {
        ele.LastUpdatedOn = this.$config.LocalTime(new Date(ele.LastUpdatedOn))
        ele.url = this.$config.baseURL + '/api/Attachments/' + ele.DocFileId
        ele.videoThumbUrl = ele.url
        if (ele.Type === 'TaskVideo') {
          ele.videoThumbUrl += '?getVideoThumbImg=true'
        }
      })
      form.TaskFiles.forEach(ele => {
        ele.LastUpdatedOn = this.$config.LocalTime(new Date(ele.LastUpdatedOn))
        ele.url = this.$config.baseURL + '/api/Attachments/' + ele.DocFileId
        ele.IsImage = ele.Name.indexOf('.png') !== -1 || ele.Name.indexOf('.PNG') !== -1
      })
      if (form.EndDate) {
        form.EndDate = this.$config.LocalTime(new Date(form.EndDate))
      }
      if (form.StartDate) {
        form.StartDate = this.$config.LocalTime(new Date(form.StartDate))
      }
      if (form.AssignedUserIds.length > 0) {
        this.assign = form.AssignedUserIds[0]
      }
      form.CompletionRate = this.$config.getFormatNumber(form.CompletionRate)
      if (!this.tasksProgressOptions.find(q => q.Key === form.CompletionRate)) {
        form.CompletionRate = form.CompletionRate + '%'
      }
      if (form.CompletionDate) {
        form.CompletionDate = this.$config.LocalTime(new Date(form.CompletionDate))
      }
      if (form.TaskType === 0) {
        this.form = form
      }
      if (form.TaskType === 1 && form.TaskProduct) {
        if (form.TaskSubtype === 1) {
          form.Product = {
            NetArea: 0,
            TotalQty: form.TaskProduct.TotalQty,
            Unit: 'SF',
            transformTotal: form.TaskProduct.TotalQty,
            transformNetArea: 0
          }
        } else {
          form.Product = await this.$config.handleProduct(form.TaskProduct, form.TaskShapes)
        }
        this.form = form
        if (form.TaskType === 1 && form.TaskSubtype === 1) {
          await this.getNonM2ProductById(this.form.TaskProduct.ProductId)
        }
      }
      if (form.TaskType === 4) {
        this.getProduct(form.TaskChildens)
        this.form = form
      }
      if (form.TaskType === 2) {
        form.Reading = await this.getReading(form.TaskId)
        this.form = form
      }

      let taskShapeList = []
      if (this.form.TaskShapes) {
        this.form.TaskShapes.forEach(ele => {
          if (ele.ShapeName && ele.ShapeName.length > 0) {
            taskShapeList.push(ele)
          }
        })
      }
      this.shapeList = this.$config.arrUnique(taskShapeList, 'RoomShapeId')
      if (this.PlanType !== 0 && this.form.TaskShapes && this.form.TaskShapes.length > 0) {
        this.locationText = this.form.TaskShapes[0].ShapeName
      }
      this.loading = false
    },
    getQtyInstall () {
      this.changeRate(this.form.CompletionRate)
    },
    async getProduct (children) {
      let assignType = []
      for (let i of children) {
        i.Product = await this.$config.handleProduct(i.TaskProduct, i.TaskShapes)
        assignType.push(i.AssignType)
      }
      assignType = this.$config.arrUnique(assignType)
      this.children = []
      for (let i of assignType) {
        let productObj = {
          list: []
        }
        productObj.type = i
        switch (i) {
          case 0:
            productObj.Name = this.$t('model.Floor')
            break
          case 1:
            productObj.Name = this.$t('model.Wall')
            break
          case 2:
            productObj.Name = this.$t('model.Base/LF')
            break
          case 3:
            productObj.Name = this.$t('model.Door')
            break
        }
        for (let j of children) {
          if (j.AssignType === productObj.type) {
            let jCopy = _.cloneDeep(j)

            productObj.list.push(jCopy)
          }
        }
        let totalCom = 0
        let totalEach = 0
        for (let k of productObj.list) {
          totalEach += 1
          totalCom += k.CompletionRate
        }
        productObj.rate = this.$config.getFormatNumber(totalCom / totalEach)
        if (productObj.list.length > 0) {
          this.children.push(productObj)
        }
      }
      this.children = this.$config.sortArray(this.children, 'type', 'asc')
      this.setChildrenProductInfo(this.productList)
    },
    setChildrenProductInfo (productList) {
      if (productList && productList.length > 0) {
        for (let c of this.children) {
          if (c.list && c.list.length > 0) {
            for (let i of c.list) {
              let obj = productList.find(q => q.id === i.TaskProduct.SKU)
              if (obj) {
                let copyProduct = _.cloneDeep(obj)
                if (i.TaskProduct.Quantity > 0) {
                  copyProduct.transformUsage = this.$config.transformUnit(i.TaskProduct.Quantity, i.TaskProduct.Unit, i.TaskProduct.ProductType).num
                } else {
                  copyProduct.transformUsage = 0
                }
                copyProduct.unit = i.Product.Unit
                copyProduct.Unit = i.TaskProduct.Unit
                copyProduct.NetArea = i.Product.NetArea
                copyProduct.transformNetArea = i.Product.transformNetArea
                copyProduct.transformTotal = i.Product.transformTotal
                copyProduct.Color = i.TaskProduct.Color
                copyProduct.showInputRadioSelect = true
                copyProduct.CompletionRate = i.CompletionRate
                // jCopy.ProductInfo = copyProduct
                this.$set(i, 'ProductInfo', copyProduct)
              }
            }
          }
        }
      }
    },
    getTotal () {
      for (let i in this.children) {
        let total = 0
        let length = this.children[i].list.length
        this.children[i].list.forEach(res => {
          total += parseFloat(res.CompletionRate)
        })
        this.children[i].rate = this.$config.getFormatNumber(total / length)
      }
    },
    save () {
      if (this.form.StartDate && this.form.EndDate) {
        if (this.form.EndDate - this.form.StartDate < 0 && (this.form.EndDate - this.form.StartDate !== 'NaN')) {
          this.$notify({
            title: this.$t('api.WARNING'),
            message: this.$t('api.Due Date need to later than Start Date'),
            duration: 3000,
            showClose: false
          })
          return
        }
      }
      if (!this.form.Name) {
        this.$notify({
          title: this.$t('api.WARNING'),
          message: this.$t('api.The Name field is required'),
          duration: 3000,
          showClose: false
        })
        return
      }
      if (this.form.TaskSubtype === 1 && this.form.TaskProduct && this.form.Product.transformTotal > this.nonM2Product.RetainageQty) {
        return
      }
      if (this.form.CompletionRate === '') {
        this.form.CompletionRate = 0
      }
      this.form.CompletionRate = parseFloat(this.form.CompletionRate)
      if (!this.form.CompletionDate && this.form.CompletionRate === 100) {
        this.form.CompletionDate = this.$config.UTCTime(null, true)
      }
      this.btnLoading = true
      if (this.form.TaskSubtype === 1 && this.form.TaskProduct) {
        this.form.TaskProduct.TotalQty = this.$config.getFormatNumber(this.form.Product.transformTotal, 2)
      }
      if (this.form.PlanType !== 0 || this.form.PlanId === null) {
        if (this.form.TaskShapes.length > 0) {
          this.form.TaskShapes[0].ShapeName = this.locationText
        } else {
          this.form.TaskShapes.push({
            TaskId: this.id,
            RoomShapeId: '0',
            ShapeArea: 0,
            ShapeId: '0',
            ShapeName: this.locationText,
            ShapePerimeter: 0,
            ShapeType: 0
          })
        }
      }
      let params = []
      params.push(this.form)
      addTask(params).then(res => {
        this.btnLoading = false
        this.closeDialog(true)
      }).catch(
        this.btnLoading = false
      )
    },
    deleteTask () {
      this.$confirm(this.$t('model.AreYouSureYouWantToDeleteThisTask'), this.$t('model.TIPS'), {
        confirmButtonText: this.$t('model.Yes'),
        cancelButtonText: this.$t('model.No'),
        type: 'warning'
      }).then(() => {
        let params = []
        params.push(this.id)
        deleteTask(params).then(res => {
          this.closeDialog(true)
        })
      }).catch(() => {
      })
    },
    getTotalCompletionRate () {
      return new Promise((resolve, reject) => {
        let total = 0
        let length = 0
        for (let i in this.children) {
          length += this.children[i].list.length
          this.children[i].list.forEach(res => {
            total += parseFloat(res.CompletionRate)
          })
        }
        this.form.CompletionRate = this.$config.getFormatNumber(total / length)
        resolve(this.form.CompletionRate)
        this.changeRate(this.form.CompletionRate)
      })
    },
    handleCompletionRateInput (row) {
      try {
        let val = parseInt(row.CompletionRate)
        if (isNaN(val) || val < 0) {
          val = 0
        }
        if (val > 100) {
          val = 100
        }
        row.CompletionRate = val
      } catch { row.CompletionRate = 0 }
    },
    async changeChild (id, rate) {
      let arr = []
      let formateRate = this.$config.getFormatNumber(rate)
      let params = {
        TaskId: id,
        CompletionRate: formateRate,
        CompletionDate: this.form.CompletionDate
      }
      if (params.CompletionDate && formateRate < 100) {
        params.CompletionDate = null
        this.form.CompletionDate = null
      }
      if (rate === 100 && !params.CompletionDate) {
        params.CompletionDate = this.$config.UTCTime(null, true)
      }
      arr.push(params)
      let taskCompletionRate = {
        TaskId: this.form.TaskId,
        CompletionRate: await this.getTotalCompletionRate(),
        Status: this.form.Status,
        CompletionDate: params.CompletionDate
      }
      arr.push(taskCompletionRate)
      changeChild(arr).then(res => {
        this.getTotal()
        this.$store.dispatch('diag/getTasksList')
      })
    },
    async changeChildGroup (group, rate) {
      this.groupRate = rate
      let arr = []
      group.forEach(ele => {
        ele.CompletionRate = this.groupRate
        let params = {
          TaskId: ele.TaskId,
          CompletionRate: this.groupRate,
          Status: this.form.Status
        }
        arr.push(params)
      })
      let taskCompletionRate = {
        TaskId: this.form.TaskId,
        CompletionRate: await this.getTotalCompletionRate(),
        Status: this.form.Status,
        CompletionDate: this.form.CompletionDate
      }
      arr.push(taskCompletionRate)
      changeChild(arr).then(res => {
        this.groupRate = 0
        this.$store.dispatch('diag/getTasksList')
      })
    },
    async markAsDone () {
      this.form.CompletionDate = this.$config.UTCTime(null, true)
      if (this.form.TaskType === 0) {
        this.form.CompletionRate = 100
        this.form.Status = 'Completed'
        let arr = []
        let taskCompletionRate = {
          TaskId: this.id,
          CompletionRate: this.form.CompletionRate,
          Status: this.form.Status,
          CompletionDate: this.form.CompletionDate
        }
        arr.push(taskCompletionRate)
        changeChild(arr).then(res => {
          this.$store.dispatch('diag/getTasksList')
        })
      }
      if (this.form.TaskType === 1) {
        this.form.CompletionRate = 100
        this.form.Status = 'Completed'
        let arr = []
        let taskCompletionRate = {
          TaskId: this.id,
          CompletionRate: this.form.CompletionRate,
          Status: this.form.Status,
          CompletionDate: this.form.CompletionDate
        }
        arr.push(taskCompletionRate)
        changeChild(arr).then(res => {
          this.$store.dispatch('diag/getTasksList')
        })
        this.getQtyInstall()
      }
      if (this.form.TaskType === 4) {
        this.form.Status = 'Completed'
        let arr = []
        for (let i in this.children) {
          this.children[i].rate = 100
          this.children[i].list.forEach(res => {
            let params = {
              TaskId: res.TaskId,
              CompletionRate: 100,
              Status: this.form.Status,
              CompletionDate: this.form.CompletionDate
            }
            res.CompletionRate = 100
            arr.push(params)
          })
        }
        let taskCompletionRate = {
          TaskId: this.id,
          CompletionRate: 100,
          Status: this.form.Status,
          CompletionDate: this.form.CompletionDate
        }
        this.form.CompletionRate = 100
        arr.push(taskCompletionRate)
        changeChild(arr).then(res => {
          this.$store.dispatch('diag/getTasksList')
        })
      }
    },
    uniqueShapes (obj) {
      const res = new Map()
      this.shapeList = obj.filter((a) => !res.has(a.RoomShapeId + a.ShapeName) && res.set(a.RoomShapeId + a.ShapeName, 1))
    },
    changeRate (rate) {
      let formateRate = rate.replace ? this.$config.getFormatNumber(rate.replace(/[^\d.]/g, '')) : this.$config.getFormatNumber(rate)
      if (isNaN(formateRate) || formateRate <= 0) {
        this.form.CompletionRate = 0
      } else {
        this.form.CompletionRate = formateRate
      }
      if (!this.tasksProgressOptions.find(q => q.Key === this.form.CompletionRate)) {
        this.form.CompletionRate = this.form.CompletionRate + '%'
      }
      if (formateRate >= 100) {
        this.form.CompletionRate = 100
        this.form.Status = 'Completed'
        this.form.CompletionDate = this.$config.UTCTime(null, true)
      } else if (formateRate < 100) {
        this.form.CompletionDate = null
      }
    },
    getTaskFiles () {
      this.condition.JobsiteId = this.jobsiteID
      this.condition.TaskId = this.id
      getFileList(this.condition).then(res => {
        res.Data.forEach(ele => {
          ele.LastUpdatedOn = this.$config.LocalTime(new Date(ele.LastUpdatedOn))
          ele.url = this.$config.baseURL + '/api/Attachments/' + ele.DocFileId
          ele.IsImage = ele.Name.indexOf('.png') !== -1 || ele.Name.indexOf('.PNG') !== -1
        })
        this.form.TaskFiles = res.Data
      })
    },
    downloadFile (id, name) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('welcome.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let nameArr = name.split('.')
      axios({
        method: 'get',
        url: this.$config.baseURL + '/api/Attachments/' + id,
        responseType: 'blob',
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
          'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
        }
      }).then((res) => {
        let blob = new Blob([res], {
          type: `application` + nameArr[nameArr.length - 1]
        })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.style.display = 'none'
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
        loading.close()
      })
    },
    deleteTaskFile (item) {
      this.$confirm(this.$t('taskDialog.Are you sure you want to delete this file?'), this.$t('taskDialog.TIPS'), {
        confirmButtonText: this.$t('taskDialog.Yes'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        cancelButtonText: this.$t('taskDialog.No'),
        type: 'warning'
      }).then(() => {
        let params = []
        params.push({
          TaskId: item.TaskId,
          DocFileId: item.DocFileId,
          IsJobsiteFile: item.IsJobsiteFile
        })
        deleteFile(params).then(res => {
          this.getTaskFiles()
          this.$store.commit('diag/setRefreshTaskList', true)
        })
      }).catch(() => {
      })
    },
    composeTaskFileCommand (type) {
      return {
        type: type
      }
    },
    handleTaskFileCommand (commmand) {
      if (commmand.type === 1) {
        this.openUpload(false)
      } else if (commmand.type === 2) {
        this.openProjectFileDialog()
      }
    },
    openProjectFileDialog () {
      this.selectProjectFileDialog.showDialog = true
      this.selectProjectFileDialog.taskId = this.id
      this.selectProjectFileDialog.taskFileIds = []
      this.form.TaskFiles.forEach(ele => {
        this.selectProjectFileDialog.taskFileIds.push(ele.DocFileId)
      })
    },
    closeProjectFileDialog (needRefresh) {
      this.selectProjectFileDialog.showDialog = false
      this.getTaskFiles()
      if (needRefresh === true) {
        this.$store.commit('diag/setRefreshTaskList', true)
      }
    },
    getNonM2ProductById (id) {
      let that = this
      let param = id + '?showTaskTotalQty=true'
      getProductById(param).then(res => {
        if (res.ProductId === that.form.TaskProduct.ProductId) {
          that.form.Product.Unit = this.$config.getNonM2ProductUnit(res.Unit)
        }
        that.nonM2Product = res
        if (!res.TaskTotalQty || res.TaskTotalQty === 0) {
          that.nonM2Product.RetainageQty = res.Quantity
        } else {
          that.nonM2Product.RetainageQty = parseFloat((res.Quantity - res.TaskTotalQty + that.form.TaskProduct.TotalQty).toFixed(2))
        }
      })
    }
  },
  components: {
    GroupDialog,
    Tem,
    InputRadioSelectPopover,
    Uploading,
    photoDialog,
    AddReadingDialog,
    ReadingList,
    selectProjectFileDialog,
    checklist,
    ProductInfo
  }
}
</script>
<style lang="scss">
.el-radio-group {
  width: 100%;
  .el-radio {
    display: block !important;
    width: 100%;
    height: 30px;
    line-height: 30px;
    .el-radio__input {
      display: none;
    }
    &.is-checked {
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 20px;
        width: 20px;
        background-image: url("../../assets/image/check.png");
        color: #4193f6;
        background-size: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
<style scoped lang="scss">
.tasks {
  position: relative;
  .img-table {
    img {
      cursor: pointer;
      height: 50px;
    }
    video {
      cursor: pointer;
      height: 50px;
    }
    .videoPlayContent {
      cursor: pointer;
      height: 50px;
      position: relative;
      .videoPlayDiv {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 40%);
      }
      .videoPlay {
        background: url(../../assets/image/play.png) no-repeat;
        background-position: 50% 50%;
        cursor: pointer;
        color: buttontext;
        width: 100%;
        height: 100%;
        display: inline-block;
      }
    }
  }
  .file-table {
    .file-img-div {
      i {
        cursor: pointer;
        display: block;
        font-size: 100px;
        color: #99a9bf;
        height: 50px;
        display: flex;
        align-items: center;
      }
    }
    .file-icon {
      max-height: 100%;
      max-width: 100%;
    }
  }
  width: 100%;
  height: 100%;
  right: -25%;
  .reading-content {
    background-color: #f2f6fc;
    cursor: pointer;
    margin-bottom: 10px;
    span {
      display: block;
      font-size: 14px;
      margin-bottom: 5px;
    }
  }
  .tem {
    margin-bottom: 16px;
    position: relative;
    .product-table {
      .name {
        color: #303133;
        font-weight: 600;
        display: block;
      }
      .text-cube {
        position: relative;
        width: 100%;
        height: 60px;
        padding-left: 70px;
        .product-cube {
          width: 54px;
          height: 54px;
          position: absolute;
          left: 3px;
          top: 3px;
          border-radius: 5px;
        }
        .rate {
          position: absolute;
          font-size: 22px;
          right: 7%;
          top: 50%;
          transform: translateY(-50%);
          color: #4193f6;
        }
        .text {
          color: #303133;
          line-height: 20px;
          display: block;
          .label {
            display: inline-block;
            width: 55px;
          }
        }
        .completionRatePopover {
          position: absolute;
          top: 10px;
          right: 5px;
        }
      }
    }
  }
  .reading-table {
    .time {
      color: #303133;
      font-weight: 600;
      display: block;
    }
  }
}
.product-info {
  .item {
    display: flex;
    .label {
      display: inline-block;
      border: 1px solid #ccc;
      background: #eee;
      width: 88px;
      text-align: right;
      padding: 5px;
    }
    .content {
      display: inline-block;
      border: 1px solid #ccc;
      border-left: none;
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding: 5px;
    }
  }
}
.tasks-show {
  right: 0;
}
.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
.checklistTemplate {
  margin-bottom: 5px;
  padding: 8px;
  background: #eee;
  color: #606266;
}
.checklistItem {
  color: #606266;
  display: flex;
  align-items: center;
  cursor: pointer;
  .check-container {
    width: 32px;
    .check-div {
      display: inline-block;
      color: #fff;
      text-align: center;
      vertical-align: middle;
      width: 18px;
      height: 18px;
      border-radius: 3px;
      border: 1px solid #999;
      .check-icon {
        vertical-align: middle;
        margin-left: -1px;
      }
    }
  }
  .item-name {
    flex: 1;
    padding: 6px 0;
  }
  &:not(:last-child) {
    .item-name {
      border-bottom: 1px solid #aaa;
    }
  }
  &:last-child {
    margin-bottom: 5px;
  }
}
.checklist-dropdown {
  max-height: 200px;
  overflow: auto;
}
.checklist-dropdown::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #f5f5f5;
}
.checklist-dropdown::-webkit-scrollbar-track {
  //-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
</style>
